import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import IconError from '../IconError';

import app from '../../app.module.css';
import local from './formElementStyles/button.module.css';

const TIME = 2000;
const Button = ({
    id = '',
    type = 'submit',
    testId = 'testIdSubmitButton',
    disabled = false,
    customClass = '',
    customErrorClass = '',
    onClick,
    content,
    error = {},
    clearError,
    icon = false,
    iconType = <AddCircleOutlineIcon />
}) => {
    useEffect(() => {
        if (error?.error) {
            const timeoutId = setTimeout(() => clearError(), TIME);
            return () => clearTimeout(timeoutId);
        }
    }, [error?.error]);

    return (
        <>
            <button
                id={id}
                type={type}
                data-testid={testId}
                role="button"
                disabled={disabled}
                className={`${local.button} ${local[customClass]}`}
                onClick={onClick}>
                <span className={`${icon ? `${local.withIcon}` : ''}`}>
                    {content}
                    {icon && iconType}
                </span>
            </button>
            {error?.error && (
                <div className={`${local.buttonError} ${local[customErrorClass]} ${app.fadein}`}>
                    <IconError text={error} />
                </div>
            )}
        </>
    );
};

Button.propTypes = {
    id: PropTypes.string,
    type: PropTypes.string,
    testId: PropTypes.string,
    disabled: PropTypes.bool,
    customClass: PropTypes.string,
    customErrorClass: PropTypes.string,
    onClick: PropTypes.func,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    error: PropTypes.object,
    clearError: PropTypes.any,
    icon: PropTypes.bool,
    iconType: PropTypes.string
};

export default Button;
